export default {
  // Encabezado y estado de la ocurrencia
  labels: {
    location: 'Location',
    open_from: 'Open since',
    close_until: 'Close at',
    score: 'Total score',
    execution_time: 'Execution time',
    first_signature_warning: 'You have not added any signature yet.',
    second_signature_warning: 'You have not added any additional signature yet.',
    additional_signature_warning: 'All mandatory additional signatures are required to finish the audit.',
    signature_warning_title: 'Warning!',
    signature_capture_title: 'Signature capture',
    signature_full_name: 'Full name',
    ok: 'OK',
    mifel_logic_applied: "MIFEL LOGIC APPLIED - Form ID: {form_id} {'|'} Org ID: {org_id}",
    critical_point: 'Critical point',
    excel_answer_header: 'Answer',
    excel_column_header: 'Col {n}',
    excel_table_label: 'Table:',
    excel_answer_yes: 'Yes',
    completed: 'Completed',
    final_result: 'Result'
  },

  // Buttons of the occurrence screen
  actions: {
    finish: 'Finish',
    send_to_authorization: 'Send for authorization',
    authorize: 'Authorize form',
    complete_form: 'Complete form',
    print: 'Print',
    email: 'Email',
    excel: 'Excel',
    pdf: 'PDF',
    add_signature: 'Add signature',
    signature_clear: 'Reset',
    signature_save: 'Save signature'
  },

  // Dialogs and notices while filling, finishing and authorizing
  messages: {
    alert_title: 'Alert',
    finish_confirm: 'Once the form is finished, answers can no longer be changed and signatures can no longer be added.',
    send_by_mail: 'The form was finished successfully. Do you want to send it by email?',
    uncompleted_tasks_title: 'Incomplete tasks',
    uncompleted_tasks: 'Assign a priority, a date and a responsible user to finish the form',
    resyncing_answers: 'Re-syncing answers...',
    sync_missing_title: 'Some items are not synced yet',
    sync_missing_answers: 'Unanswered:',
    sync_missing_addons: 'Missing items:',
    sync_missing_addon: 'Missing {type} in "{title}"',
    validation_table_empty: 'The table : {name} is empty. Please fill in the empty fields.',
    validation_table_empty_cells: 'There are empty fields in : {name}. Please fill in the empty fields.',
    validation_footer: 'Answer the missing items and try again',
    no_group: 'No group',
    unnamed_item: 'Unnamed item',
    item_id: 'ID {id}',
    addon_comment: 'Comment',
    addon_picture: 'Image',
    addon_document: 'Document',
    syncing_offline_answers: 'Syncing offline answers...',
    offline_answers_synced: 'Offline answers synced successfully',
    authorizing: 'Authorizing form...',
    authorized: 'Form authorized successfully',
    deadline_active: '⚠️ This form has an active time limit',
    deadline_due: 'It must be completed before: {date}',
    understood: 'Got it',
    na_group_title: 'Mark group as N/A',
    na_group_confirm: 'Every answer in "{group}" will be marked as N/A, including the ones already answered. Do you want to continue?',
    send_by_email_title: 'Send form by email',
    send_by_email_label: 'Enter one or more emails',
    send_by_email_ok: 'Send',
    reset_answers_confirm: 'All answers entered so far will be permanently deleted.',
    answers_sent: 'The answers were sent',
    connection_lost: 'Internet connection lost, saving answers in offline mode.',
    connection_restored: 'Internet connection restored.'
  },

  // Resultado de autoevaluación (badges/reporte)
  self_evaluation_result: {
    low: 'Low',
    marginal: 'Marginal',
    standard: 'Standard',
    food_security: 'Food security',
    local_standards: 'Local Standards',
    brand_standards: 'Brand Standards',
    final: 'Result'
  },

  // Generación y descarga del PDF de la ocurrencia
  pdf: {
    generating: 'Generating PDF...',
    taking_long: 'Your PDF is taking longer than usual. We\'ll notify you when it\'s ready.',
    ready_in_notifications: 'Your PDF is ready. You\'ll find it in your notifications.',
    downloaded: 'Your PDF was downloaded.',
    generate_error: 'We couldn\'t generate the PDF. Please try again.',
    retry: 'Retry',
    back: 'Back',
    downloading_title: 'Downloading your file...',
    downloading_subtitle: 'This may take a few seconds.',
    done_title: 'Download ready',
    done_subtitle: 'Check your downloaded files.',
    error_title: 'We couldn\'t download the file',
    error_subtitle: 'The link may have expired. Request the file again.'
  },

  // Linked tasks of the occurrence
  tasks: {
    edit_title: 'Edit Title',
    priority: 'Priority',
    days: 'days',
    assigned_to: 'Assigned to',
    user: 'User',
    category: 'Category',
    end_date: 'Due date',
    area: 'Area',
    hierarchy_optional: 'Hierarchy (Optional)',
    enforce_evidence: 'Image required',
    assigned_task: 'Assigned task',
    overdue_task: 'Overdue task',
    pending_tasks: 'Pending tasks',
    action_plan: 'Action plan',
    delete_confirm_title: 'Confirmation',
    delete_confirm: 'Do you want to delete the task?',
    changes_saved: 'Changes saved',
    assigned_by: 'Assigned by',
    assigned_to_label: 'Assigned to'
  },

  // Question list of the fill and its add-ons
  items: {
    campaign_points_hint: 'This question counts toward campaign points.',
    camera_only: 'Only camera capture is allowed.',
    watch_video: 'Watch video',
    delete_item_title: 'Warning: Irreversible Action',
    delete_item_confirm: "Are you sure you want to delete '{name}' and all its content?"
  },

  // Answer fields by question type (Field*)
  fields: {
    total: 'Total',
    totals_not_configured: 'Totals were not configured',
    updating: 'Updating...',
    check_in: 'Check In',
    previous_reading: 'Previous reading',
    current_reading: 'Current reading',
    difference: 'Difference',
    document_approved: 'Document approved',
    document_rejected: 'Document rejected',
    document_saved: 'The document was saved successfully.',
    document_deleted: 'Deleted successfully',
    default_document_name: 'document',
    analyzing_image: 'Analyzing image'
  }
}
